import AboutAsOne from "../../pages/aboutAsOne/AboutAsOne";
import Dashboard from "../../pages/dashboard/Dashboard";
import LoginPage from "../../pages/login/LoginPage";
import Policies from "../../pages/policies/Policies";
import { NavigationConstantsInterface } from "./Interfaces.constants";
import Notification from "../../pages/notification/Notification";
import Group from "../../pages/group/Group";
import CorporateCommunication from "../../pages/SideMenu/corporateCommunication/CorporateCommunication";
import LivingResponsibility from "../../pages/SideMenu/livingResponsibility/LivingResponsibility";
import TrainingQuiz from "../../pages/trainingQuiz/TrainingQuiz";
import PeopleForm from "../../pages/PeopleForm/PeopleForm";
import People from "../../pages/people/People";
import Photos_Challenge from "../../pages/Photo_Challenge/Photo_Challenge";
import Video_Challenge from "../../pages/VideoChallenge/VideoChallenge";
import Quiz from "../../pages/Quiz/Quiz";
import AddQuiz from "../../pages/Quiz/AddQuiz";
import Zigsaw_Challenge from "../../pages/ZigsawChallenge/ZigawChallenge";
import Kahoot_Challenge from "../../pages/KahootQuiz/KahootQuiz";
import MyConnect from "../../pages/myConnect/MyConnect";
import GroupForm from "../../pages/group/GroupForm";
import Post_Listing from "../../pages/Post_Listing/Post_Listing";
import Zoom_Webinar from "../../pages/Zoom_Webinar/Zoom_Webinar";
import Wall_Listing from "../../pages/Wall_Listing/Wall_Listing";
import AddWallPost from "../../pages/Wall_Listing/Add_Wall_Post";
import AddTrainingQuiz from "../../pages/trainingQuiz/AddTrainingQuiz";
import TrainingQuizDetails from "../../pages/trainingQuiz/TrainingQuizDetails";
import PhotoChallengeDetails from "../../pages/Photo_Challenge/PhotoChallengeDetails";
import VideoChallengeDetails from "../../pages/VideoChallenge/VideoChallengeDetails";
import TrainingForm from "../../pages/TrainingForm/TrainingForm";
import MyConnectSidebar from "../../pages/myConnect/myConnectSidebar";
import Items from "../../pages/myConnect/ItemList";
import QuizDetails from "../../pages/Quiz/QuizDetails";
import AddGallery from "../../pages/gallery/add-gallery/AddGallery";
import AddFolder from "../../pages/gallery/add-folder/AddFolder";
import Gallery from "../../pages/gallery/add-gallery/Gallery";
import appVersion from "../../pages/appVersion/appVersion";
import Report_User from "../../pages/Wall_Listing/Report_User";
import Survey from "../../pages/survey/Survey";
import SurveyForm from "../../pages/survey/SurveyForm";
import Add_Post from "../../pages/Post_Listing/Add_Post";
import EditTrainingForm from "../../pages/TrainingForm/EditTrainingForm";
import Training from "../../pages/Training/Training";
import hrChat from "../../pages/HR-Chat/hrChat";
import ViewTrainingContent from "../../pages/TrainingForm/ViewTrainingContent";
import PollData from "../../pages/TrainingForm/PollData";
import QuizData from "../../pages/Quiz/QuizData";
import QuizDatas from "../../pages/TrainingForm/QuizData";
import AddContentForm from "../../pages/TrainingForm/AddContentForm";
// import ContentDetails from "../../pages/TrainingForm/ContainDetails";
import SurveyDetails from "../../pages/survey/SurveyDetails";
import EditContent from "../../pages/TrainingForm/EditContent";
import EditContentForm from "../../pages/TrainingForm/EditContent";
import NewTrainingCard from "../../pages/TrainingForm/NewTrainingCard";
import leaderboard from "../../pages/leaderBoard/leaderboard";
import AddSurveyQuiz from "../../pages/survey/AddSurveyQuiz";
import Leaderboard from "../../pages/leaderBoard/leaderboard";
import ChatScreen from "../../pages/HR-Chat/ChatScreen";
import ChangePoint from "../../pages/leaderBoard/changePoint";
import Anylitics from "../../pages/Anylitics/anylitics";


const NavigationConst: Array<NavigationConstantsInterface> = [
  // {
  //   id: 1000,
  //   path: "/admin/login",
  //   element: LoginPage,
  //   authRequired: false,
  //   indexRoute: false,
  // },
  {
    id: 1001,
    path: "/privacy-policy",
    element: Policies,
    authRequired: true,
    indexRoute: false,
  },
  {
    id: 1002,
    path: "/dashboard",
    element: Dashboard,
    authRequired: true,
    indexRoute: true,
  },
//   {
//     id: 1001,
//     path: "/dashboard",
//     element: Dashboard,
//     authRequired: false,
//     indexRoute: false,
//   },
  {
    id: 1004,
    path: "/about-as-one",
    element: AboutAsOne,
    authRequired: true,
    indexRoute: false,
  },
  {
    id: 1005,
    path: "/notification",
    element: Notification,
    authRequired: true,
    indexRoute: false,
  },
  {
    id: 1006,
    path: "/people",
    element: People,
    authRequired: true,
    indexRoute: false,
  },
  {
    id: 1007,
    path: "/people/add",
    element: PeopleForm,
    authRequired: true,
    indexRoute: false,
  },
  {
    id: 1008,
    path: "/people/edit",
    element: PeopleForm,
    authRequired: true,
    indexRoute: false,
  },
  {
    id: 1009,
    path: "/group",
    element: Group,
    authRequired: true,
    indexRoute: false,
  },
  {
    id: 1010,
    path: "/trainings",
    element: Training,
    authRequired: true,
    indexRoute: false,
  },
  {
    id: 1011,
    path: "/training/add",
    element: TrainingForm,
    authRequired: true,
    indexRoute: false,
  },

  {
    id: 1012,
    path: "/training-quiz",
    element: TrainingQuiz,
    authRequired: true,
    indexRoute: false,
  },
  {
    id: 1021,
    path: "/training-quiz/addQuiz",
    element: AddTrainingQuiz,
    authRequired: true,
    indexRoute: false,
  },
  {
    id: 1022,
    path: "/training-quiz/quizByFolder/:id",
    element: TrainingQuizDetails,
    authRequired: true,
    indexRoute: false,
  },
  {
    id: 1013,
    path: "/corporate-communication",
    element: CorporateCommunication,
    authRequired: true,
    indexRoute: false,
  },
  {
    id: 1014,
    path: "/living-responsibility",
    element: LivingResponsibility,
    authRequired: true,
    indexRoute: false,
  },
  {
    id: 1015,
    path: "/survey",
    element: Survey,
    authRequired: true,
    indexRoute: false,
  },
  // {
  //   id: 1016,
  //   path: "/add-gallery",
  //   element: AddGallery,
  //   authRequired: false,
  //   indexRoute: false,
  // },
  {
    id: 1017,
    path: "/gallery",
    element: Gallery,
    authRequired: true,
    indexRoute: false,
  },
  {
    id: 1018,
    path: "/add-folder",
    element: AddFolder,
    authRequired: true,
    indexRoute: false,
  },
  {
    id: 1019,
    path: "/gallery/add-gallery",
    element: AddGallery,
    authRequired: true,
    indexRoute: false,
  },

  {
    id: 1020,
    path: "/group/create",
    element: GroupForm,
    authRequired: true,
    indexRoute: false,
  },

  {
    id: 1021,
    path: "/group/edit",
    element: GroupForm,
    authRequired: true,
    indexRoute: false,
  },

  {
    id: 1022,
    path: "/photo-challenge",
    element: Photos_Challenge,
    authRequired: true,
    indexRoute: false,
  },
  {
    id: 1023,
    path: "/video-challenge",
    element: Video_Challenge,
    authRequired: true,
    indexRoute: false,
  },
  {
    id: 1024,
    path: "/quiz",
    element: Quiz,
    authRequired: true,
    indexRoute: false,
  },
  {
    id: 1025,
    path: "/quiz/AddQuiz",
    element: AddQuiz,
    authRequired: true,
    indexRoute: false,
  },
  {
    id: 1031,
    path: "/culturalPost",
    element: Post_Listing,
    authRequired: true,
    indexRoute: false,
  },
  {
    id: 1032,
    path: "/wall",
    element: Wall_Listing,
    authRequired: true,
    indexRoute: false,
  },
  {
    id: 1032,
    path: "/post/add",
    element: AddWallPost,
    authRequired: true,
    indexRoute: false,
  },
  {
    id: 1026,
    path: "/my-connect", // path: "/my-connect/:id/:title",
    element: MyConnectSidebar,
    authRequired: true,
    indexRoute: false,
  },
  {
    id: 1027,
    path: "/my-connect/:id/:title", // path: "/my-connect/:id/:title",
    element: MyConnect,
    authRequired: true,
    indexRoute: false,
  },
  {
    id: 1028,
    path: "/item-details/:id/:title",
    element: Items,
    authRequired: true,
    indexRoute: false,
  },

  {
    id: 1028,
    path: "/zigsaw-challenge",
    element: Zigsaw_Challenge,
    authRequired: true,
    indexRoute: false,
  },
  {
    id: 1029,
    path: "/kahoot-quiz",
    element: Kahoot_Challenge,
    authRequired: true,
    indexRoute: false,
  },
  {
    id: 1030,
    path: "/zooms",
    element: Zoom_Webinar,
    authRequired: true,
    indexRoute: false,
  },
  {
    id: 1031,
    path: "/quiz/detail",
    element: QuizDetails,
    authRequired: true,
    indexRoute: false,
  },
  {
    id: 1032,
    path: "/photo-challenge/:id",
    element: PhotoChallengeDetails,
    authRequired: true,
    indexRoute: false,
  },
  {
    id: 1033,
    path: "/video-challenge/:id",
    element: VideoChallengeDetails,
    authRequired: true,
    indexRoute: false,
  },
  {
    id: 1034,
    path: "/report-user",
    element: Report_User,
    authRequired: true,
    indexRoute: false,
  },
  {
    id: 1035,
    path: "/survey/add",
    element: SurveyForm,
    authRequired: true,
    indexRoute: false,
  },
  {
    id: 1032,
    path: "/appVersion",
    element: appVersion,
    authRequired: true,
    indexRoute: false,
  },
  {
    id: 1033,
    path: "/report-user",
    element: Report_User,
    authRequired: true,
    indexRoute: false,
  },
  {
    id: 1034,
    path: "/culturalPost/addPostGroup",
    element: Add_Post,
    authRequired: true,
    indexRoute: false,
  },
  {
    id: 1035,
    path: "/hr-chat",
    element: ChatScreen,
    authRequired: true,
    indexRoute: false,
  },
  {
    id: 1036,
    path: "/training/edit/:id",
    element: EditTrainingForm,
    authRequired: true,
    indexRoute: false,
  },
  {
    id: 1037,
    path: "/training/view/:id",
    element: ViewTrainingContent,
    authRequired: true,
    indexRoute: false,
  },
  {
    id: 1038,
    path: "/poll-data/:id",
    element: PollData,
    authRequired: true,
    indexRoute: false,
  },
  {
    id: 1039,
    path: "/quiz-data/:id",
    element: QuizDatas,
    authRequired: true,
    indexRoute: false,
  },
  {
    id: 1040,
    path: "/content-add",
    element: AddContentForm,
    authRequired: true,
    indexRoute: false,
  },
  {
    id: 1041,
    path: "/survey/edit",
    element: SurveyForm,
    authRequired: true,
    indexRoute: false,
  },
  {
    id: 1041,
    path: "/content-edit",
    element: EditContentForm,

    authRequired: true,
    indexRoute: false,
  },
  {
    id: 1042,
    path: "/survey/addQuiz",
    element: AddSurveyQuiz,
    authRequired: true,
    indexRoute: false,
  },
  {
    id: 1043,
    path: "/survey/:name",
    element: SurveyDetails,
    authRequired: true,
    indexRoute: false,
  },
  {
    id: 1044,
    path: "/leaderboard",
    element: Leaderboard,
    authRequired: true,
    indexRoute: false,
  },
  {
    id: 1045,
    path: "/leaderboard/changePoint",
    element: ChangePoint,
    authRequired: true,
    indexRoute: false,
  },
  {
    id: 1046,
    path: "/",
    element: Dashboard,
    authRequired: true,
    indexRoute: true,
    },
    {
    id: 1047,
    path: "/anylitics",
    element: Anylitics,
    authRequired: true,
    indexRoute: false,
  },
  {
    id: 1048,
    path: "/trainingContent",
    element: NewTrainingCard,
    authRequired: true,
    indexRoute: false,
  },

];

export default NavigationConst;
